import Footer from 'components/Header/Footer'
import Header from 'components/Header/Header'
import AmericaList from './AmericaList'
import React from 'react'

const AmericaUni = () => {
  return (
    <div className='main'>
<Header/>
<AmericaList/>
<Footer/>

    </div>
  )
}

export default AmericaUni